exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.group-title[data-v-56c40bd2]{\n  font-weight: 700;\n  font-size:16px;\n  text-transform: uppercase;\n}\n.v-list__tile__title[data-v-56c40bd2]{\n  height:52px;\n  line-height: 40px;\n}\n.v-list__tile__content[data-v-56c40bd2]{\n  font-size:14px;\n  font-family: 'Open Sans', sans-serif;\n}\n.v-list__tile[data-v-56c40bd2]{\n  padding:0;\n}\n", ""]);

// exports
